import { render, staticRenderFns } from "./BannerLeft.vue?vue&type=template&id=06254816&"
import script from "./BannerLeft.vue?vue&type=script&lang=js&"
export * from "./BannerLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports